import { gql } from '@apollo/client';

export const GET_TOP_SEARCHES = gql`
  query getTopSearches {
    topSearches: getTopSearches
  }
`;
